import React, {useEffect} from "react";
import {LocationForm, LocationRequestPartial, WorkingHoursRequest} from "./createAndUpdate/LocationForm";
import {
    clearUpdateLocationState,
    fetchLocationToUpdate,
    initialLocationLoadingStatusSelector,
    UpdateLocationRequestPartial,
    updateAftersalesWorkingHours,
    updateLocation,
    updateLocationErrorMessageSelector,
    updateLocationRequestSelector,
    updateLocationRequestStatusSelector,
    updateUpdateLocationRequest,
    updateWorkingHours
} from "../locationUpdateSlice";
import {createLocationRequestPropertySelector} from "./selector/LocationStoreSelector";
import {useAppDispatch, useAppSelector} from "../../../../app/hooks";
import {Loader} from "../../../elements/loader/Loader";
import {fetchLocationList} from "../locationListSlice";
import {RequestStatus} from "../../../../api/apiConfiguration";
import {
    showErrorToastNotification,
    showSuccessToastNotification
} from "../../../elements/toastNotification/toastNotificationSlice";

interface UpdateLocationFormProps {
    publicId: string
    handleClose: () => void
}

export const UpdateLocationForm: React.FC<UpdateLocationFormProps> = ({publicId, handleClose}) => {

    const dispatch = useAppDispatch();
    const initialLocationLoadingStatus = useAppSelector(initialLocationLoadingStatusSelector);
    const updateLocationRequestStatus = useAppSelector(updateLocationRequestStatusSelector);
    const errorMessage = useAppSelector(updateLocationErrorMessageSelector);

    useEffect(() => {
        if (initialLocationLoadingStatus === RequestStatus.NONE) {
            dispatch(fetchLocationToUpdate(publicId))
        }
        return () => {
            dispatch(clearUpdateLocationState());
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (updateLocationRequestStatus === RequestStatus.RESOLVED) {
            dispatch(fetchLocationList())
            handleClose()
            dispatch(showSuccessToastNotification({message: "Location Updated Successfully"}))
        } else if (updateLocationRequestStatus === RequestStatus.REJECTED) {
            dispatch(showErrorToastNotification({message: errorMessage || "Failed to update location"}))
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [updateLocationRequestStatus]);

    if (initialLocationLoadingStatus === RequestStatus.RESOLVED) {

        const handleUpdateWorkingHours = (update: WorkingHoursRequest & { fieldName: string }) => {
            dispatch(updateWorkingHours(update));
        }

        const handleUpdateAftersalesWorkingHours = (update: WorkingHoursRequest & { fieldName: string }) => {
            dispatch(updateAftersalesWorkingHours(update));
        }


        const updateRequest = (update: LocationRequestPartial) => {
            dispatch(updateUpdateLocationRequest(update as UpdateLocationRequestPartial))
        }

        const onSubmit = () => {
            dispatch(updateLocation())
        }

        return <LocationForm
            formTitle={"Update location"}
            onClose={handleClose}
            onSubmit={onSubmit}
            updateRequest={updateRequest}
            selectionProvider={createLocationRequestPropertySelector(updateLocationRequestSelector)}
            updateWorkingHours={handleUpdateWorkingHours}
            updateAftersalesWorkingHours={handleUpdateAftersalesWorkingHours}
        />
    } else {
        return <Loader/>
    }
}
